import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import { useDispatch, useSelector } from "react-redux";
import { useDropzone } from "react-dropzone";
import CircularProgress from "@mui/material/CircularProgress";
import Button from "@mui/material/Button";
import { cloneDeep } from "lodash";

import CloudUploadIcon from "@mui/icons-material/CloudUploadOutlined";
import { uploadingTheFile } from "../../FMForm/FormHelpers/UploadingFile";
import { getFileName } from "../../../../services/FilesService";
import { handleMessageTypeTable } from "../../../../state/actionsHelpers/tabStackActionsHelpers/message-type-table";
import { uuidGenerator } from "../../../../utils/general";
import { setUploadFileLoader } from "../../../../state/actions/loader";

const SectionContainer = styled("section")(({ theme }) => ({
	border: "dashed 1.2px #e8e8e8",
	borderRadius: 6,
	marginBlock: 10,
	width: "100%",
	height: 60,
	textAlign: "center",
}));

const ButtonContainer = styled(Button)(({ theme }) => ({
	borderRadius: 6,
	border: "solid 1.2px #e8e8e8",
	backgroundColor: "#ffffff",
	fontSize: 12,
	marginTop: 10,
	padding: "3px 15px",
}));

const CircularProgressContainer = styled(CircularProgress)(({ theme }) => ({
	position: "absolute",
	top: "50%",
	left: "50%",
	marginTop: -12,
	marginLeft: -12,
}));

const FMTableAttachment = ({
	conversation,
	options,
	handleInlineFormAction,
	parentTabId = null,
	parentDocId = null,
	setShowMandatory,
	message
}) => {
	const dispatch = useDispatch();
	const [isLoading, setIsLoading] = useState(false);
	const botParamsRaw = localStorage.getItem("botParams");
	let botParamsData = botParamsRaw ? JSON.parse(botParamsRaw) : null;

	const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
		multiple: true,
		disabled: isLoading,
	});

	const selectedConversation = useSelector((state) => state.chats.selectedConversation);
	const selectedConversationId = selectedConversation?.conversationId;
	const currentUserDomain = selectedConversation?.userDomain;


	const [scopeId, setScopeId] = useState(() => {
		switch (options?.fileScope) {
			case "bot": {
				return botParamsData.botId;
			}

			case "domain": {
				return currentUserDomain;
			}

			case "conversation":
			default: {
				return selectedConversationId;
			}
		}
	});

	useEffect(() => {
		const processFiles = async () => {
			if (acceptedFiles.length > 0) {
				let temp = [];
				for (const file of acceptedFiles) {
					try {
						let fileDetailObj = file;
						let fileName = file ? file.name : "";
						let createFileName = getFileName();
						createFileName += fileName.substr(
							fileName.lastIndexOf("."),
							fileName.length - 1
						);
						dispatch(setUploadFileLoader(true))
						setIsLoading(true);
						let rowId = uuidGenerator();
						
						let data = await uploadingTheFile(
							fileDetailObj,
							conversation,
							createFileName,
							options?.fileScope,
							scopeId,
							dispatch
						);
						if (data) {
							const newRow = {
								fields: cloneDeep(options.columnTemplate),
								rowOptions: {
									newRow: true,
								},
							};
							newRow.fields.forEach((el) => {
								if (el.type === "file_field") {
									el.value = data.split("/").pop();
									el.fileName = fileName;
									el.readOnly = true;
									handleInlineFormAction("move", rowId, el.id, {
										currentFieldValue: el.value,
										fileName: el.fileName,
									});
								}
							});
							temp = [{ [rowId]: newRow }, ...temp];
							// dispatch(setBotWaitLoaderWithShimmer(false))

						}
					} catch (err) {
						console.error("ERROR on file Upload =>> ", err);
						setIsLoading(false);
					}
				}
				console.log("HERE ===> TEMP", temp);
				let formMessage = {
					message: {
						update: [...temp, ...message],
					},
					options: {
						action: "change",
						controlId: options.controlId,
						tableId: options.tableId,
						tabId:
							options?.parent?.length || options.sectionId
								? parentTabId
								: options.tabId,
						sectionId: options.sectionId ? options.sectionId : null,
						parentDocId,
						parent: options.parent,
					},
				};
				dispatch(handleMessageTypeTable(conversation, formMessage, true));
				setIsLoading(false);
				setShowMandatory(true);
			}
		};

		processFiles();

		return () => {
			setIsLoading(false);
		};
	}, [acceptedFiles]);

	return (
		<SectionContainer>
			<div {...getRootProps({ className: "dropzone" })}>
				<input {...getInputProps()} />
				<ButtonContainer
					variant="outlined"
					disabled={isLoading}
					startIcon={
						// isLoading ? (
						// 	<CircularProgressContainer size={24} />
						// ) : (
						<CloudUploadIcon className="!w-[16px]" />
						// )
					}
				>
					{isLoading ? "Uploading.." : "Upload documents"}
				</ButtonContainer>
			</div>
		</SectionContainer>
	);
};

export default FMTableAttachment;
